import React from "react";
import { BottomNavigationWrapper } from "./bottomNavigationStyle";
import searchSvg from "assets/images/icons/search.svg";
import searchActiveSvg from "assets/images/icons/search-active.svg";
import userSvg from "assets/images/icons/user.svg";
import userActiveSvg from "assets/images/icons/user-active.svg";
import marketSvg from "assets/images/icons/market.svg";
import marketActiveSvg from "assets/images/icons/market-active.svg";
import homeSvg from "assets/images/icons/home.svg";
import homeActiveSvg from "assets/images/icons/home-active.svg";
import communitySvg from "assets/images/icons/community.svg";
import communityActiveSvg from "assets/images/icons/community-active.svg";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path !== "/" && location.pathname.includes(path)) {
      return true;
    }

    return false;
  };

  return (
    <BottomNavigationWrapper>
      <NavigationItem
        style={location.pathname === "/" ? { color: "#FF7A00" } : { color: "" }}
      >
        <img
          src={location.pathname === "/" ? homeActiveSvg : homeSvg}
          alt="home"
          onClick={() => navigate("/")}
        />
        홈
      </NavigationItem>
      <NavigationItem isActive={isActive("/dashboard")}>
        <img
          src={isActive("/dashboard") ? searchActiveSvg : searchSvg}
          alt="home"
          onClick={() => navigate("/dashboard")}
        />
        꽃 검색
      </NavigationItem>
      <NavigationItem isActive={isActive("/market")}>
        <img
          src={isActive("/market") ? marketActiveSvg : marketSvg}
          alt="home"
          onClick={() => navigate("/market")}
        />
        시장정보
      </NavigationItem>
      <NavigationItem isActive={isActive("/boards")}>
        <img
          src={isActive("/boards") ? communityActiveSvg : communitySvg}
          alt="home"
          onClick={() => navigate("/boards")}
        />
        커뮤니티
      </NavigationItem>
      <NavigationItem isActive={isActive("/mypage")}>
        <img 
          src={isActive("/mypage") ? userActiveSvg : userSvg} 
          alt="home"
          onClick={() => navigate("/mypage")} />
          내 정보
      </NavigationItem>
    </BottomNavigationWrapper>
  );
};

export default BottomNavigation;

const NavigationItem = styled.div`
  color: ${(props) => (props.isActive ? "#FF7A00 !important;" : "")};
`;
